import { render } from "./GymHowItWorks.vue?vue&type=template&id=3d7f43e4&scoped=true"
import script from "./GymHowItWorks.vue?vue&type=script&lang=js"
export * from "./GymHowItWorks.vue?vue&type=script&lang=js"

import "./GymHowItWorks.vue?vue&type=style&index=0&id=3d7f43e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7f43e4"]])

export default __exports__